import React from 'react'
import Field from '../common/Field'
import I18n from 'i18n'
import { durationFromISOString } from '../../../../common/Utils'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { TimeAgoElement } from '../../../../common/TimeAgo'
import { Link } from 'react-router-dom'
import Routes from '../../../../common/Routes'

const WeFitterDefaultFlavour = (props) => {
  const icon = props.icon
  const metadatum = props.metadatum

  const activityValue = (activity, dataRow) => {
    switch (activity) {
      case 'heart_rate_avg':
        return Math.round(dataRow.heart_rate_summary?.average) || null
      case 'sleep_duration':
        return durationFromISOString(dataRow.sleep_summary?.duration)
      case 'calories':
        return Math.round(dataRow.calories) || null
      default:
        return Math.round(dataRow[activity]) || null
    }
  }

  const weFitterActivitiesSummary = (dataRow) => {
    const activities = [
      'steps',
      'calories',
      'heart_rate_avg',
      'sleep_duration'
    ]
    return activities.map((activity) => {
      const value = activityValue(activity, dataRow)
      const title = I18n.t(`components.timeline.card.${activity}`)

      return <Field key={activity} title={title} value={value} />
    })
  }

  const heartRateSamplesSummary = (dataRow) => {
    const samples = dataRow.heart_rate_samples
    if (!samples || !Array.isArray(samples) || samples.length < 1) return null

    const values = samples.map(s => Number(s.value)).filter(v => !isNaN(v))
    if (values.length < 1) return null

    const avg = Math.round(values.reduce((a, b) => a + b, 0) / values.length)
    const min = Math.min(...samples.map(s => Number(s.min)).filter(v => !isNaN(v)))
    const max = Math.max(...samples.map(s => Number(s.max)).filter(v => !isNaN(v)))

    return [
      <Field key='hr-avg' title={I18n.t('components.timeline.card.heart_rate_avg')} value={`${avg} bpm`} />,
      isFinite(min) && <Field key='hr-min' title={I18n.t('components.timeline.card.heart_rate_min')} value={`${min} bpm`} />,
      isFinite(max) && <Field key='hr-max' title={I18n.t('components.timeline.card.heart_rate_max')} value={`${max} bpm`} />
    ].filter(Boolean)
  }

  const sleepDetailSummary = (dataRow) => {
    const segments = dataRow.sleep_detail
    if (!segments || !Array.isArray(segments) || segments.length < 1) return null

    const levels = segments.reduce((acc, seg) => {
      const level = seg.level || 'unknown'
      if (!acc[level]) acc[level] = 0
      acc[level] += 1
      return acc
    }, {})

    return Object.entries(levels).map(([level, count]) => {
      const title = level.charAt(0).toUpperCase() + level.slice(1)
      return <Field key={`sleep-${level}`} title={title} value={`${count} segments`} />
    })
  }

  const biometricMeasurementsSummary = (dataRow) => {
    const measurements = dataRow.biometric_measurements
    if (!measurements || !Array.isArray(measurements) || measurements.length < 1) return null

    const grouped = measurements.reduce((acc, row) => {
      const key = row.measurement_type || 'unknown'
      if (!acc[key]) acc[key] = { sum: 0, count: 0, unit: row.unit }
      acc[key].sum += Number(row.value) || 0
      acc[key].count += 1
      return acc
    }, {})

    return Object.entries(grouped).map(([type, { sum, count, unit }]) => {
      const measurementType = type.replace(/_/g, ' ').toLowerCase()
      const title = measurementType.charAt(0).toUpperCase() + measurementType.slice(1)
      const avg = Math.round(sum / count)
      const value = unit ? `${avg} ${unit}` : `${avg}`

      return <Field key={`biometric-${type}`} title={title} value={value} />
    })
  }

  return (
    <>
      <div className='timeline-compact-wrapper'>
        {icon && (
          <div className='timeline-icon-compact center-align'>
            <FontAwesomeIcon icon={icon} />
          </div>
        )}
        <div style={{ width: '100%' }}>
          {metadatum && (
            <div className='timeline-compact-title-wrapper'>
              <Link
                to={Routes.data.showFn(
                  metadatum && metadatum.versioned_data_object_id
                )}
              >
                <div className='text-l text-heavy text-primary-color pointer from-group'>
                  {(metadatum && (metadatum.title || metadatum.filename)) ||
                    I18n.t('components.data.untitled_file')}
                </div>
              </Link>
              <p className='timeline-profile-details text-s text-muted'>
                <TimeAgoElement date={new Date(metadatum.event_start)} />
              </p>
            </div>
          )}
          {props.sdo.data_rows && (() => {
            const dataRow = props.sdo.data_rows[props.sdo.data_rows.length - 1]
            const allFields = [
              ...weFitterActivitiesSummary(dataRow),
              ...(heartRateSamplesSummary(dataRow) || []),
              ...(sleepDetailSummary(dataRow) || []),
              ...(biometricMeasurementsSummary(dataRow) || [])
            ].filter(field => field.props?.value)
            return (
              <div className='sport-fields'>
                {allFields.slice(0, 5)}
              </div>
            )
          })()}
        </div>
      </div>
    </>
  )
}

export default WeFitterDefaultFlavour
